import type { CallFallbackConfigModel } from '@src/service/model'

import Repository from './base'

export const CALL_FALLBACK_CONFIG_TABLE_NAME = 'callFallbackConfig'
export class CallFallbackConfigRepository extends Repository<CallFallbackConfigModel> {}
